import { useDevicesStore } from "./store";

export function useDeviceLocations() {
  return useDevicesStore((state) => state.devices);
}
